import { render, staticRenderFns } from "./RequirementOverview.vue?vue&type=template&id=1da49c9c"
import script from "./RequirementOverview.vue?vue&type=script&lang=ts"
export * from "./RequirementOverview.vue?vue&type=script&lang=ts"
import style0 from "./RequirementOverview.vue?vue&type=style&index=0&id=1da49c9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports